import { Backend } from '@/_axios';

export default {
  list(params) {
    return Backend.post('/translations/list/', params);
  },
  untranslated() {
    return Backend.get('/translations/untranslated_cnt');
  },
  createData() {
    return Backend.get('/translations/create');
  },
  editData(id) {
    return Backend.get(`/translations/${id}/edit`);
  },
  create(data) {
    return Backend.post('/translations/', data);
  },
  update(data) {
    return Backend.put('/translations/', data);
  },
  delete(id) {
    return Backend.delete(`/translations/${id}`);
  },
};
